import { useQuery } from '@tanstack/react-query';
import { useDebouncedMemo } from '@hooks/debounceAsync';
import CatalogService from '@utility/services/catalog';
import { catalogMappingKeys } from '../lib/query-keys';
import type { MappingItem, MappingItemsParams } from '../lib/types';

/* The API refuses a longer search. */
const MAX_SEARCH_LENGTH = 100;

const noItems: MappingItem[] = [];

/* Catalog items of the account a listing can be mapped to, by title or SKU. */
export function useMappingItems(search: string, enabled: boolean) {
  const applied = useDebouncedMemo<string>(
    () => search.trim().slice(0, MAX_SEARCH_LENGTH),
    [search],
    300,
    '',
  );
  const params: MappingItemsParams = applied ? { search: applied } : {};

  const query = useQuery({
    queryKey: catalogMappingKeys.mappingItems(params),
    queryFn: ({ signal }) => CatalogService.getMappingItems(params, signal),
    enabled,
  });

  return {
    items: query.data?.data ?? noItems,
    loading: query.isFetching,
    error: query.error,
  };
}
